package devxertech.com.pages.services.aiDevelopmentService.developmentServices

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.TeamService
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun AiServices(breakpoint: Breakpoint,
               sitePalette: SitePalette){
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 40.px,
                bottom = if (breakpoint < Breakpoint.MD) 20.px else 30.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "AI DEVELOPMENT SERVICES",
                asH2 = true,
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = 18.px,
                textAlign = TextAlign.Center
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "WHAT WE ",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700,
                    letterSpacing = 1.px
                )
                FieldTitleTextNormalSimple(
                    "OFFER?",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700,
                    letterSpacing = 1.px
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(bottom = if (breakpoint < Breakpoint.MD) 10.px else if (window.screen.width > 1600) 10.px else 80.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                TeamService(
                    image = Res.Image.ai_Chatbot,
                    title = "Internal AI assistants",
                    description = "Assist employees with recurring questions by connecting an assistant to approved business knowledge and useful internal workflows. The project scope depends on data access, permissions and technical feasibility.",
                )
                TeamService(
                    image = Res.Image.nlpLogo,
                    title = "NLP",
                    description = "NLP solutions help machines understand human language better. " +
                            "By enhancing language understanding, NLP streamlines communication" +
                            " between humans and machines. It facilitates more efficient " +
                            "decision-making processes across various applications and industries.",
                )
                TeamService(
                    image = Res.Image.predective_analysis,
                    title = "Predictive Analytics",
                    description = "Utilizing advanced statistical and machine learning algorithms," +
                            " our predictive analysis solutions ensure accurate predictions of " +
                            "forthcoming events and outcomes. By examining past trends and data" +
                            " points, this service provides valuable insights to anticipate and" +
                            " plan for future scenarios.",
                )
                if (window.screen.width < 1600) {
                    TeamService(
                        image = Res.Image.machineLearning,
                        title = "Machine learning",
                        description = "In our machine learning service use data-driven algorithms" +
                                " to unlock actionable insights and drive trans formative solutions" +
                                " By analyzing extensive datasets, machine learning models can " +
                                "recognize patterns and adapt to evolving circumstances. ",
                    )


                    TeamService(
                        image = Res.Image.computerVision,
                        title = "Computer Vision",
                        description = "we offer a comprehensive computer vision service that " +
                                "opens up new horizons in visual data interpretation. From improving" +
                                " diagnostics in healthcare to image recognition, our computer" +
                                " vision service is at the forefront of driving transformative " +
                                "change and progress.",
                        modifier = Modifier.padding(bottom = 40.px)

                    )
                    TeamService(
                        image = Res.Image.chatgpt_Integration,
                        title = "Chat GPT integration",
                    description = "Connect an AI assistant to selected internal tools and information sources where platform access and technical feasibility allow. Keep defined review steps for work that needs human judgement. "

                    )
                }
            }
            if (window.screen.width > 1600) {
                Row(modifier = Modifier.fillMaxWidth()
                    .padding(top = 0.px, bottom = if (window.screen.width > 1600) 20.px else 70.px).display(DisplayStyle.Flex)
                    .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TeamService(
                        image = Res.Image.machineLearning,
                        title = "Machine learning",
                        description = "In our machine learning service use data-driven algorithms" +
                                " to unlock actionable insights and drive trans formative solutions" +
                                " By analyzing extensive datasets, machine learning models can " +
                                "recognize patterns and adapt to evolving circumstances. ",
                        modifier = Modifier.padding(bottom = 40.px)

                    )
                    TeamService(
                        image = Res.Image.computerVision,
                        title = "Computer Vision",
                        description = "we offer a comprehensive computer vision service that " +
                                "opens up new horizons in visual data interpretation. From improving" +
                                " diagnostics in healthcare to image recognition, our computer" +
                                " vision service is at the forefront of driving transformative " +
                                "change and progress.",
                        modifier = Modifier.padding(bottom = 40.px)

                    )
                    TeamService(
                        image = Res.Image.chatgpt_Integration,
                        title = "Chat GPT integration",
                        description = " We empower your platform to automate responses, " +
                                "handle queries effectively, and engage users in natural and " +
                                "meaningful conversations. This saves time and resources and also" +
                                " sets you apart in the competitive landscape of AI-powered communication. "
                        )
                }
            }
        }
    }
}
